function Order(data) {
    this.customerId = ko.observable(data.customerId || data.CustomerId);
    this.id = ko.observable(data.id || data.Id);
    this.totalDue = ko.observable(data.totalDue || data.TotalDue);
    this.extraData = ko.observable(data.extraData || data.ExtraData);
    this.currency = new Currency(data.currency || data.Currency);
    this.discount = new Discount(data.discount || data.Discount);
    this.orderDetail = new OrderDetail(data.orderDetail || data.OrderDetail);
    this.isDiscounted = ko.computed(function () {
        return this.discount && this.discount.amount() > 0;
    }, this);
}

function OrderDetail(data) {
    this.productId = ko.observable(data.productId || data.ProductId);
    this.productName = ko.observable(data.productName || data.ProductName);
    this.productLabel = ko.observable(data.productLabel || data.ProductLabel);
    this.productDescription = ko.observable(data.productDescription || data.ProductDescription);
    this.productPrice = ko.observable(data.productPrice || data.productPrice || 0.0);
    this.productUrl = ko.observable(data.productUrl || data.ProductUrl);
}

function Currency(data) {
    this.id = ko.observable(data.id || data.Id);
    this.symbol = ko.observable(data.symbol || data.Symbol);
}

function Discount(data) {
    this.code = ko.observable(data.code || data.Code || '');
    this.name = ko.observable(data.name || data.Name || '');
    this.amount = ko.observable(data.amount || data.Amount || 0.0);
}

function PurchaseResult(data) {
    if (!data) { return; }
    this.orderId = data.orderId;
    this.productId = data.productId;
    this.isSuccess = data.isSuccess && typeof data.isSuccess === "boolean" ? true : false;
    this.isCancellation = data.isCancellation && typeof data.isCancellation === "boolean" ? true : false;
    this.provider = data.provider;
    this.additionalData = data.additionalData;
}

function OrderDiscount(data) {
    this.orderId = data.orderId || data.OrderId;
    this.discountCode = data.discountCode || data.DiscountCode;
    this.customerId = data.customerId || data.CustomerId;
    this.isApplied = data.isApplied || data.IsApplied;
    this.isValid = data.isValid || data.IsValid;
    this.oldPrice = data.oldPrice || data.OldPrice;
    this.newPrice = data.newPrice || data.NewPrice;
    this.discountAmount = data.discountAmount || data.DiscountAmount;
    this.discountName = data.discountName || data.DiscountName;
    this.currencyId = data.currencyId || data.CurrencyId;
    this.currencySymbol = data.currencySymbol || data.CurrencySymbol;
}

export const models = {
    Order: Order,
    OrderDetail: OrderDetail,
    Currency: Currency,
    Discount: Discount,
    PurchaseResult: PurchaseResult,
    OrderDiscount: OrderDiscount
};